import { L as Linkify } from "../chunks/Linkify-BtgR-dXX.mjs";
const directive = function(el, binding) {
  if (binding.value?.linkify === true) {
    el.innerHTML = Linkify(binding.value.text);
  }
};
export {
  directive as default,
  directive
};
